import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ListTemplateComponent } from '../list';
import { ArchiveFiltersComponent } from './archive-filters';
import { ArchiveTableComponent } from './archive-table';


/**
 * Component for archive list.
 */
@Component({
	selector: 'app-archive',
	templateUrl: './archive.component.html',
	imports: [
		ListTemplateComponent,
		ArchiveTableComponent,
		ArchiveFiltersComponent
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ArchiveComponent { }
